import { render, staticRenderFns } from "./SearchEvents.vue?vue&type=template&id=85f7a738&scoped=true&"
import script from "./SearchEvents.vue?vue&type=script&lang=js&"
export * from "./SearchEvents.vue?vue&type=script&lang=js&"
import style0 from "./SearchEvents.vue?vue&type=style&index=0&id=85f7a738&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85f7a738",
  null
  
)

component.options.__file = "SearchEvents.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!/opt/build/repo/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VForm } from 'vuetify/lib'
import { VHover } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {VCard,VContainer,VFlex,VForm,VHover,VLayout,VTextField})
